import { FireQuotation } from './components';

export const StepFour = () => <FireQuotation />;
